import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Progress from 'reactstrap/lib/Progress';
import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';
import { getPlural } from 'client/utils/plural';

import './rating-lines.scss';

const RATING_ROW_INDEXES = [5, 4, 3, 2, 1];

export function RatingLines({ ratings, total, isAvailable }) {
  if (!ratings && !total) {
    return null;
  }

  return (
    <ul className="list-unstyled mb-0" aria-label="Rating">
      {RATING_ROW_INDEXES.map(key => (
        <Row tag="li" className="rating-lines text-gray-darker mb-0_5" noGutters key={key}>
          <Col xs="auto d-flex align-items-center">
            <span className="small mb-0">{key}</span>
            <span className="visually-hidden">
              &nbsp;{getPlural('star', key)}: {ratings[`star${key}`]} out of {total}
            </span>
            <span
              className={classnames('medium rating-star icon-star-full rating-star-ml mx-0_5', {
                'text-primary-darker': isAvailable,
              })}
              aria-hidden
            />
          </Col>
          <Col className="d-flex flex-column justify-content-center" aria-hidden>
            <Progress className="rounded" color="primary-darker" value={ratings[`star${key}`]} max={total} />
          </Col>
          <Col className="d-flex flex-column justify-content-center" xs={2} aria-hidden>
            <div className="small ms-0_5 text-center">({ratings[`star${key}`]})</div>
          </Col>
        </Row>
      ))}
    </ul>
  );
}

RatingLines.propTypes = {
  ratings: PropTypes.objectOf(PropTypes.number),
  total: PropTypes.number,
  isAvailable: PropTypes.bool,
};

RatingLines.defaultProps = {
  ratings: null,
  total: 0,
  isAvailable: false,
};
